"use client";

import React from "react";
import { Compass, Cpu, Printer, Settings, Wrench, ArrowRight } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  title: "Digital Transformation",
  icon: Cpu,
  description: "We audit your existing infrastructure to integrate intelligent automation and cloud-native architectures for maximum scalability."
}, {
  title: "Business Strategy",
  icon: Compass,
  description: "Our consultants design high-level roadmaps that align your operational capabilities with emerging market opportunities."
}, {
  title: "AI Solutions",
  icon: Settings,
  description: "Deploying custom machine learning models and generative AI tools to optimize decision-making and internal workflows."
}, {
  title: "Financial Advisory",
  icon: Printer,
  description: "Precision-driven fiscal modeling and risk assessment to ensure your growth is backed by sustainable capital structures."
}, {
  title: "Growth Marketing",
  icon: Wrench,
  description: "Data-backed execution of market entry and expansion tactics, leveraging digital ecosystems for premium brand positioning."
}];
export default function WhyLeadersChooseFmc() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  return <section data-section-id="224041" id="why-leaders-choose-fmc" className="bg-background text-foreground">
      <div className="bg-card/30 py-24 lg:py-32 overflow-hidden backdrop-blur-sm">
        <div className="container mx-auto px-4 md:px-6">
          
          <div className="max-w-3xl mx-auto text-center mb-16 md:mb-24">
            <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6 tracking-tighter">
              The FMC Methodology
            </h2>
            <p className="text-lg text-muted-foreground font-default">
              A future-focused framework designed to propel modern enterprises through innovation, technology, and strategic liquid intelligence.
            </p>
          </div>

          <div className="relative w-full overflow-x-auto pb-12 snap-x snap-mandatory hide-scrollbar" ref={ref}>
            <div className="min-w-[1200px] lg:min-w-full relative px-4 lg:px-0">
              
              {}
              <div className="absolute top-8 left-0 w-full h-1 bg-border/20 rounded-md" />
              
              {}
              <div className="absolute top-8 left-0 h-1 bg-primary rounded-md transition-all duration-1500 ease-out" style={{
              width: isVisible ? '100%' : '0%'
            }} />

              <div className="flex justify-between items-start relative z-10">
                {steps.map((step, i) => <div key={i} data-index={i} className="flex flex-col items-center w-64 snap-center shrink-0">
                    <div className="w-16 h-16 rounded-lg bg-background border-2 border-primary flex items-center justify-center text-primary shadow-lg shadow-primary/20 mb-8 relative z-10 transition-transform duration-500 hover:scale-110">
                      <step.icon className="w-8 h-8" />
                    </div>
                    
                    <Card className="w-full bg-card/60 backdrop-blur-xl border-border/10 shadow-xl hover:shadow-primary/5 transition-shadow duration-300 rounded-xl">
                      <CardHeader className="pb-3 text-center">
                        <div className="text-xs font-mono text-secondary font-bold mb-1 uppercase tracking-widest">Phase 0{i + 1}</div>
                        <CardTitle className="font-default text-xl text-foreground">{step.title}</CardTitle>
                      </CardHeader>
                      <CardContent>
                        <CardDescription className="text-center text-sm leading-relaxed text-muted-foreground font-default">
                          {step.description}
                        </CardDescription>
                      </CardContent>
                    </Card>
                  </div>)}
              </div>
            </div>
          </div>

          <div className="mt-16 text-center">
            <Button asChild size="lg" className="rounded-md px-8 bg-primary text-primary-foreground hover:shadow-[0_0_20px_rgba(0,255,255,0.4)] transition-all">
              <Link to="/StrategicPillarsPage">
                Explore Strategic Pillars
                <ArrowRight className="ml-2 w-4 h-4" />
              </Link>
            </Button>
          </div>

        </div>
      </div>
    </section>;
}